import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { Modal } from 'react-bootstrap';
import { TypeReport } from './types';

type ModalCustomStyleProps = {
  typeReport: TypeReport;
  isMobile: boolean;
};

export const ModalCustom = styled(Modal, {
  shouldForwardProp: (prop) => prop !== 'typeReport' && prop !== 'isMobile',
})<ModalCustomStyleProps>`
  & .modal-dialog {
    max-width: 100vw;
    max-height: 100vh;
    padding: 8px;
    margin: 0;
  }

  & .modal-content {
    & > div {
      height: calc(100vh - 16px);
      overflow: hidden;

      #componenteGrafico {
        min-height: 280px;
      }
    }
  }

  @media (min-width: 769px) {
    & .modal-dialog {
      padding: 35px;
    }

    & .modal-content {
      & > div {
        height: calc(100vh - 70px);
        overflow: hidden;

        #componenteGrafico {
          min-height: 340px;
        }

        ${({ typeReport, isMobile }) =>
          typeReport === 'graph' &&
          !isMobile &&
          css`
            height: 512px;
          `}
      }
    }
  }
`;

export const Container = styled.div`
  background: #ffffff;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 16px;
  overflow: hidden;

  @media (min-width: 769px) {
    border: none;
    padding: 16px 19px;
  }
`;

export const MessageWrap = styled.div`
  background: #ffffff;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;

  @media (min-width: 769px) {
    min-height: 340px;
    padding: 0;
  }
`;

export const MessageLoading = styled.h1`
  font-size: 1.5rem;

  @media (min-width: 769px) {
    font-size: 2rem;
  }
`;
